interface ProgressBarProps {
  label: string
  value: number
  max?: number
  tone?: 'blue' | 'green' | 'amber'
  showValue?: boolean
}

export function ProgressBar({ label, value, max = 100, tone = 'blue', showValue = true }: ProgressBarProps) {
  const safeMax = Math.max(1, max)
  const safeValue = Math.max(0, Math.min(safeMax, value))
  const percentage = (safeValue / safeMax) * 100

  return (
    <div className={`progress progress--${tone}`}>
      <div className="progress__meta">
        <span>{label}</span>
        {showValue && <strong>{safeValue}/{safeMax}</strong>}
      </div>
      <div
        className="progress__track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={safeMax}
        aria-valuenow={safeValue}
      >
        <span className="progress__fill" style={{ transform: `scaleX(${percentage / 100})` }} />
      </div>
    </div>
  )
}
